import { AlpineComponent } from "@nxtlvlsoftware/alpine-typescript/";
import { NotifierComponent } from "./notifier.component";
import { NotificationInstance } from "./notifier.component.types";

export class NotificationComponent extends AlpineComponent {
    private instance: NotificationInstance;

    public Show:boolean = false;

    constructor(instance: NotificationInstance){
        super();
        this.instance = instance;
    }

    async init() {
        await this.$nextTick();
        this.Show = true;
        setTimeout(() => this.TransitionOut(), 10000);
    }

    public TransitionOut() {
        this.Show = false;
        setTimeout(() => (this.$data as unknown as NotifierComponent).remove(this.instance), 500);
    }
}